export const createMarkerPosition = (geolocation) => {
  return geolocation ? { lat: geolocation[0], lng: geolocation[1] } : null;
};

export const createMarkerObject = ({ reference, geolocation, status, location }) => {
  if (!geolocation) return null;
  const position = { lat: geolocation[0], lng: geolocation[1] };
  return { id: reference, position, status, location };
};
